import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Card from "../../../components/Cards/Card";
import { Col, Row, Grid } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Back, Statistics } from "../../../components/Icons/Icons";
import DocumentUploadCard from "../../../components/CustomControls/DocumentUpload/DocumentUploadCard";
import { CustomImage } from "../../../components/CustomControls/Image";
import profilePic from "../../../assets/img/faces/face-0.jpg";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import TrialStatusChip from "../../../components/CustomControls/TrialStatusChip";
import {
  attachmentCategories,
  attachmentEntityType,
} from "../../../variables/Enums";
import { usePractitionerStartup, useUser } from "../../Users/Hooks";
import { uploadAttachmentMetadata } from "../../../api/clinicalTrial";

export const EditMemberTeamContainer = () => {
  const { t } = useTranslation();
  const { id: practitionerId } = useParams();
  const [practitioner, setPractitioner, isLoading] =
    usePractitionerStartup(practitionerId);
  const [isUserLoading, user] = useUser(practitionerId);
  const navigation = useHistory();

  const studies = (practitioner?.startups || []).map((s) => ({
    id: s.id,
    acronym: s.protocol?.title || `N/A-${s.id}`,
    pathology: s.protocol?.indication?.description,
    coordinator: s.protocol?.principalInvestigator?.fullName,
    status: s.protocol?.status?.code,
  }));

  const statusCounts =
    practitioner?.startups?.reduce((acc, startup) => {
      const code = startup.protocol?.status?.code;
      if (code) {
        acc[code] = (acc[code] || 0) + 1;
      }
      return acc;
    }, {}) || {};

  const handleAttachmentChange = async (attachment) => {
    if (attachment?.id && attachment?.extendedMetadata) {
      try {
        await uploadAttachmentMetadata(
          attachmentEntityType.Practitioner,
          attachment.id,
          attachment.extendedMetadata
        );
      } catch (err) {
        console.error("Error al actualizar metadata:", err);
      }
    }

    setPractitioner((prev) => ({
      ...prev,
      attachments: prev.attachments.map((currentAttachment) =>
        currentAttachment.attachmentCategoryId ===
        attachment.attachmentCategoryId
          ? { ...currentAttachment, ...attachment }
          : currentAttachment
      ),
    }));
  };

  return (
    <div className="p-4 space-y-4 container-fluid">
      <div
        style={{
          display: "flex",
          marginBottom: "10px",
          justifyContent: "end",
        }}
      >
        <button
          className="btn btn-default btn-fill"
          type="button"
          onClick={() => navigation.goBack()}
        >
          <Back /> {t("buttons.back")}
        </button>
      </div>
      <Card
        className="card-patient"
        content={
          <Row>
            <Col sm={3}>
              <div className="patient-avatar">
                <CustomImage src={profilePic} defaultSrc={profilePic} />
              </div>
            </Col>
            <Col sm={9}>
              <Row>
                <div className="info">
                  <div className="name">{user?.fullName}</div>
                </div>
              </Row>
              <Row>
                <Col sm={4} style={{ paddingLeft: 0 }}>
                  <div className="info">
                    <div>
                      <span className="patient-label">Teléfono móvil:</span>{" "}
                      <span className="patient-text">
                        {user?.telecom?.cellPhone}
                      </span>
                    </div>
                    <div>
                      <span className="patient-label">Identificación:</span>{" "}
                      <span className="patient-text">
                        {user?.identificationNumber}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="info">
                    <div>
                      <span className="patient-label">Teléfono fijo:</span>{" "}
                      <span className="patient-text">
                        {user?.telecom?.phone}
                      </span>
                    </div>
                    <div>
                      <span className="patient-label">Matrícula:</span>{" "}
                      <span className="patient-text">
                        {user?.registrationNumber ?? ""}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="info">
                    <div>
                      <span className="patient-label">Email:</span>{" "}
                      <span className="patient-text">{user?.userName}</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        }
      />
      <Card
        className="card-patient-edit card-form"
        content={
          <Row>
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 style={{ display: "inline-block", margin: 10 }}>
                Ensayos Clínicos
              </h5>
              <span
                style={{
                  padding: "6px 12px",
                  borderRadius: "20px",
                  fontWeight: "bold",
                  fontSize: "14px",
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#D3D3D3",
                }}
              >
                {studies.length}
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#808080",
                    borderRadius: "50%",
                    marginLeft: "8px",
                  }}
                />
              </span>
            </div>
            <Col sm={10} style={{ margin: "0 auto", float: "none" }}>
              <BootstrapTable
                bordered={false}
                hover
                keyField="id"
                data={studies}
                columns={[
                  { dataField: "acronym", text: "Acrónimo" },
                  { dataField: "pathology", text: "Patologías" },
                  { dataField: "coordinator", text: "Coordinador" },
                  {
                    dataField: "status",
                    text: "Status",
                    formatter: (cell) => <TrialStatusChip status={cell} />,
                  },
                ]}
                pagination={paginationFactory({
                  hideSizePerPage: true,
                  sizePerPage: 5,
                })}
                noDataIndication={() => <>{t("commons.noData")}</>}
                classes="table-spaced table-spaced-small"
                wrapperClasses="table-responsive"
              />
            </Col>
          </Row>
        }
      />
      <Card
        content={
          <Row>
            <Col md={6}>
              <DocumentUploadCard
                attachmentEntityTypeId={attachmentEntityType.Practitioner}
                entityId={practitionerId}
                attachment={practitioner?.attachments?.find(
                  (x) => x.attachmentCategoryId === attachmentCategories.CVs
                )}
                legend={"Subir documento"}
                onAttachmentChange={handleAttachmentChange}
              />
            </Col>
            <Col md={6}>
              <DocumentUploadCard
                attachmentEntityTypeId={attachmentEntityType.Practitioner}
                entityId={practitionerId}
                attachment={practitioner?.attachments?.find(
                  (x) => x.attachmentCategoryId === attachmentCategories.GCP
                )}
                legend={"Subir documento"}
                onAttachmentChange={handleAttachmentChange}
              />
            </Col>
          </Row>
        }
      />
      <Card
        content={
          <Row>
            <Col md={6}>
              <DocumentUploadCard
                attachmentEntityTypeId={attachmentEntityType.Practitioner}
                entityId={practitionerId}
                attachment={practitioner?.attachments?.find(
                  (x) =>
                    x.attachmentCategoryId === attachmentCategories.iataFile
                )}
                legend={"Subir documento"}
                onAttachmentChange={handleAttachmentChange}
              />
            </Col>
            <Col md={6}>
              <DocumentUploadCard
                attachmentEntityTypeId={attachmentEntityType.Practitioner}
                entityId={practitionerId}
                attachment={practitioner?.attachments?.find(
                  (x) =>
                    x.attachmentCategoryId ===
                    attachmentCategories.dangerousGoodFile
                )}
                legend={"Subir documento"}
                onAttachmentChange={handleAttachmentChange}
              />
            </Col>
          </Row>
        }
      />

      <Card
        className="card-icon-data"
        content={
          <Grid fluid>
            <Row className="display-flex">
              <Col sm={2}>
                <div className="icon-box">
                  <Statistics />
                </div>
              </Col>
              <Col sm={10}>
                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th>{t("clinicalTrials.brief.proposal")}</th>
                      <th>{t("clinicalTrials.brief.discarded")}</th>
                      <th>{t("clinicalTrials.brief.startup")}</th>
                      <th>{t("clinicalTrials.brief.recruiting")}</th>
                      <th>{t("clinicalTrials.brief.onHold")}</th>
                      <th>{t("clinicalTrials.brief.followUp")}</th>
                      <th>{t("clinicalTrials.brief.close")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="statistics">
                      {/* <td className="goal">23</td> */}
                      {/* <td className="scrn">23</td> */}
                      <td className="default">
                        {statusCounts["Proposal"] || 0}
                      </td>
                      <td className="default">
                        {statusCounts["Discarded"] || 0}
                      </td>
                      <td className="default">
                        {statusCounts["StartUp"] || 0}
                      </td>
                      <td className="default">
                        {statusCounts["Recruiting"] || 0}
                      </td>
                      <td className="default">{statusCounts["OnHold"] || 0}</td>
                      <td className="default">
                        {statusCounts["OnGoing"] || 0}
                      </td>
                      <td className="default">{statusCounts["Closed"] || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Grid>
        }
      />
    </div>
  );
};
